import PropTypes from 'prop-types'
import styled, { css } from 'styled-components'

import colors from 'components/utils/colors'

import Badge, { StyledBadge } from 'components/Shared/Badge/Index'

const StyledBadgedItem = styled.div`
  display: inline-flex;
  font-size: 14px;
  align-items: center;
  justify-content: start;
  ${StyledBadge} {
    margin: 0 6px 0 0;
  }

  ${props => props.badgePosition === 'right' && css`
    flex-direction: row-reverse;
    ${StyledBadge} {
      margin: 0 0 0 6px;
    }
  `}

  ${props => props.bold && css`
    font-weight: 600;
    color: ${colors.secondary40};
  `}
`

const BadgedItem = ({
  badgeContent, big, bold, badgePosition, badgeColor, children,
  badgeTooltip, badgeTooltipId,
}) => {
  return (
    <StyledBadgedItem badgePosition={badgePosition} bold={bold}>
      <Badge
        color={badgeColor}
        big={big}
        data-tooltip-content={badgeTooltip}
        data-tooltip-id={badgeTooltipId}
      >
        {badgeContent}
      </Badge>
      {children}
    </StyledBadgedItem>
  )
}

BadgedItem.propTypes = {
  badgeContent: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.string,
  ]),
  big: PropTypes.bool,
  bold: PropTypes.bool,
  badgePosition: PropTypes.string,
  badgeColor: PropTypes.string,
  children: PropTypes.node,
  badgeTooltip: PropTypes.string,
  badgeTooltipId: PropTypes.string,
}

export default BadgedItem
